<template>
    <section id="paymentsSection" class="checkout-section">
        <div class="section-header">
            <h2>{{ resources.title }}</h2>
            <button class="btn btn--secondary" v-if="!disableEditMode && readMode && hasEnabledDeliveryMethods" @click="leaveReadMode()">{{resources.editCTA}}</button>
        </div>
        <div class="section-row" v-if="!readMode && hasEnabledDeliveryMethods">
            <span class="section-row-header">{{ resources.chooseMethod }}</span>
            <giftcard-block key="giftcard" v-if="!hasNoGiftCardOptions" />

            <div v-if="paymentMethodError" class="section-row">
                <div class="inline-alert error">
                    <span>{{paymentMethodError}}</span>
                </div>
            </div>

            <div class="vertical-tile-list section-row" v-if="hasRegularPaymentMethods">
                <payment-method-tile
                    v-for="(method, index) in filteredPaymentMethods"
                    :key="method.type"
                    :method="method"
                    :isSelected="isSelected(index, method)"
                    :readOnly="false"
                    v-on:selected="selectPaymentMethod" />
            </div>

            <div v-if="preselectedPaymentMethod && (['scheme', 'bcmc'].indexOf(selectedPaymentMethod.type) < 0 || payingFullAmountWithGiftcard)" class="section-row">
                <div v-if="showEditModeError" class="section-row">
                    <div class="inline-alert error">
                        <span>{{saveDeliverySettingsWarning}}</span>
                    </div>
                </div>
                <footer class="section-footer">
                    <button class="btn" @click="savePaymentChanges()" :disabled="showSpinner">
                        <div :class="['spinner', 'white-spinner', { 'spinner-visible': showSpinner }]">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>

                        <template v-if="!showSpinner">
                            {{resources.savePaymentSettingsCTA}}
                        </template>
                    </button>

                    <button class="link" @click="removePaymentChanges()">{{resources.cancelCTA}}</button>
                </footer>
            </div>
        </div>
        <div class="section-row" v-if="readMode && hasEnabledDeliveryMethods">
            <giftcard-block key="giftcard-readonly" v-if="!hasNoGiftCardOptions" />
            <div v-if="paymentMethodError" class="section-row">
                <div class="inline-alert error">
                    <span>{{paymentMethodError}}</span>
                </div>
            </div>
            <div class="vertical-tile-list vertical-tile-list-space" v-if="hasRegularPaymentMethod">
                <payment-method-tile
                    :key="selectedPaymentMethod.type + '-readOnly'"
                    :method="selectedPaymentMethod"
                    :isSelected="true"
                    :readOnly="true"
                    v-on:selected="selectPaymentMethod" />
            </div>
        </div>
    </section>
</template>

<script src='./payments-block.js'></script>
